import { createBrowserRouter, Navigate } from 'react-router-dom';
import Home from '@/pages/home/Home.jsx';
import Assets from '@/pages/assets/Assets.jsx';
import Login from '@/pages/login/index.jsx';
// import Signup from '@/pages/signup/index.jsx';
// import Verify from '@/pages/verify/index.jsx';
// import ForgotPassword from '@/pages/forgotPassword/index.jsx';
// import SetPassword from '@/pages/setPassword/index.jsx';
// import SetPasswordSuccess from '@/pages/setpasswordsuccess/index.jsx';
import Pricing from '@/pages/pricing/Pricing.jsx';
import Aivoices from '@/pages/aivoices/Aivoices.jsx';
import Settings from '@/pages/settings/Settings.jsx';
import Space from '@/pages/space/index.jsx';
import DashBoardLayout from '@/components/layouts/dashboard/Dashboard.jsx';
import Edit from '@/pages/edit/Edit.jsx';
import Tool from '@/pages/tool/Tool.jsx';
import AccountLayout from '@/components/layouts/account/index.jsx';

import { RequireAuth } from '@/utils/auth.jsx';
import Recording from '@/pages/recording/index.jsx';
import Survey from '@/pages/survey/index.jsx';
import View from '@/pages/view/index.jsx';
const businessRoutes = [
  {
    path: '',
    element: <DashBoardLayout />,
    children: [
      {
        path: 'home',
        element: <Home />,
      },
      {
        path: 'assets',
        element: <Assets />,
      },
      {
        path: 'aivoices',
        element: <Aivoices />,
      },
      {
        path: 'space',
        element: <Space />,
      },
      {
        path: 'settings',
        element: <Settings />,
      },
    ],
  },
  {
    path: '',
    element: <AccountLayout />,
    children: [
      {
        path: 'login',
        element: <Login />,
      },
    ],
  },
  {
    path: 'recording',
    element: <Recording />,
  },
  {
    path: 'pricing',
    element: <Pricing />,
  },
  // {
  //   path: '',
  //   element: <AccountLayout />,
  //   children: [
  //     {
  //       path: 'signup',
  //       element: <Signup />,
  //     },
  //   ],
  // },
  // {
  //   path: '',
  //   element: <AccountLayout />,
  //   children: [
  //     {
  //       path: 'verify',
  //       element: <Verify />,
  //     },
  //   ],
  // },
  // {
  //   path: '',
  //   element: <AccountLayout />,
  //   children: [
  //     {
  //       path: 'setPassword',
  //       element: <SetPassword />,
  //     },
  //   ],
  // },
  // {
  //   path: '',
  //   element: <AccountLayout />,
  //   children: [
  //     {
  //       path: 'forgotpassword',
  //       element: <ForgotPassword />,
  //     },
  //   ],
  // },
  // {
  //   path: '',
  //   element: <AccountLayout />,
  //   children: [
  //     {
  //       path: 'setpasswordsuccess',
  //       element: <SetPasswordSuccess />,
  //     },
  //   ],
  // },
  {
    path: 'edit',
    element: <Edit />,
  },
  {
    path: 'tool',
    element: <Tool />,
  },
  {
    path: 'survey',
    element: <Survey />,
  },
  {
    path: 'view',
    element: <View />,
  },
  {
    path: 'share',
    element: <View />,
  },
];

const routes = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/home" replace />,
  },
  {
    path: '',
    element: <RequireAuth />,
    children: businessRoutes,
  },
  {
    path: ':lang',
    element: <RequireAuth />,
    children: businessRoutes,
  },
]);

export default routes;
